import Styles from './BottomMessage.module.scss'

export const AlmostDoneMessage = () => (
  <div className={Styles.messageContainer}>
    <div className={Styles.emoji}>✨</div>
    <div className={Styles.message}>You are almost done!</div>
  </div>
)
